import { render } from "./KurvaNormalCabang.vue?vue&type=template&id=2c0d67f3"
import script from "./KurvaNormalCabang.vue?vue&type=script&lang=js"
export * from "./KurvaNormalCabang.vue?vue&type=script&lang=js"

import "./KurvaNormalCabang.vue?vue&type=style&index=0&id=2c0d67f3&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__